import React, { useState } from "react";
import styles from "./BusinessesforSale.module.css"; 
import { MdEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";


const BusinessescontactForm = () => {
  const navigate = useNavigate(); 
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    businessName: "",
    interestedIn: "",
    businessDescription: "",
    termsAccepted: false,
  });

  const handleContactClick = () => {
    navigate("/BusinessesforSale/BusinessescontactForm/Investor_Proposal"); 
};
 

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className={styles.Businesses_for_sale_formContainer}>
      <div className={styles.Businesses_for_sale_formContainerheading}>
        <h2>
          <MdEmail className={styles.icon} /> Send Business Proposal
        </h2>
        <p>One Time Registration</p>
      </div>
      <p className={styles.Businesses_p}>
        Fill business details below to send Business Proposal
      </p>
      <form onSubmit={handleSubmit}>
        <div className={styles.Businesses_for_sale_label_box}>
          <label>Full Name:</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.Businesses_for_sale_label_box}>
          <label>Phone Number:</label>
          <input
            type="tel"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.Businesses_for_sale_label_box}>
          <label>Business Name:</label>
          <input
            type="text"
            name="businessName"
            value={formData.businessName}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.Businesses_for_sale_label_box}>
          <label htmlFor="interestedIn">I am interested in:</label>
          <select
            name="interestedIn"
            value={formData.interestedIn}
            onChange={handleChange}
            required
          >
            <option value="" disabled>
              Select an option
            </option>
            <option value="fullSale">Full sale of my business</option>
            <option value="partialStakeSale">
              Partial stake sale of my business/investment
            </option>
            <option value="loan">Loan for my business</option>
            <option value="sellingCommercialRealEstate">
              Selling commercial real estate
            </option>
            <option value="franchising">Franchising my business</option>
          </select>
        </div>

        <div className={styles.Businesses_for_sale_fullwidth_box}>
          <label>Describe your business in one line:</label>
          <textarea
            name="businessDescription"
            value={formData.businessDescription}
            onChange={handleChange}
            required
            rows="4"
            cols="50"
          />
        </div>

        <div className={styles.Businesses_for_sale_checkbox}>
          <input
            type="checkbox"
            name="termsAccepted"
            checked={formData.termsAccepted}
            onChange={handleChange}
            required
          />
          <label>I accept the terms of engagement</label>
        </div>

        <button type="submit" onClick={handleContactClick} >Continue</button>
        <span>or</span>
        <button
          type="button"
          onClick={() => window.open("https://wa.me/", "_blank")}
        >
          Enquire on WhatsApp
        </button>
      </form>
    </div>
  );
};

export default BusinessescontactForm;
